import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { IconSeekers } from 'ui-seeker/core'
import { AppTooltip } from '../../@components'
import useHubSpotChat from './@hooks/useHubSpotChat'


export default function BottomNavChatButton() {

    const { t } = useTranslation('navigation')
    const { isOpen, unreadCount, toggle } = useHubSpotChat()

    return <div className={`toolItem${isOpen ? ' active' : ''}`} onClick={toggle}>
            <span className="toolIcon">
                <AppTooltip
                    title={t('user.chat')}
                    placement="right"
                >
                    <IconSeekers icon="comment-dots" iconType="fontAwesome" />
                </AppTooltip>
                {!!unreadCount && <span className="alert-notification">
                    <span className="red-circle">{unreadCount > 99 ? '99+' : unreadCount}</span>
                </span>}
            </span>
    </div>
}
